import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('put', `/api/submissions/${id}/refresh-feedback`);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/grades/refreshAutomatedFeedback.js